export const CACHED_STATE_INVITE_ACTIVATED_NAME = 'cs-ia';
export const CACHED_STATE_SHOW_INVITE_PROMPT_NAME = 'cs-sip';
